import React, { Component } from "react";
import debounce from "lodash.debounce";
import FooterImg from "../SplashScreen/image.png"

export default class FooterLayout extends Component {
  constructor(props) {
    super(props);
    this.handleResize = debounce(this.handleResize.bind(this), 400);
  }

  handleResize() {
    this.setState(this.state);
  }

  componentDidMount() {
    window.addEventListener("resize", this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  render() {
    return (
      <div className="FooterLayout">
        <div>
          <img src={ FooterImg } alt="" />
        </div>
      </div>
    );
  }
}
